"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (val) => {
    // Replace closing
    const re = /<\/\W*script/gi;
    return val.replace(re, '(/script');
};
